export default {
  'pages.repository.section.basic': '基本情報',
  'pages.repository.section.gitlab': 'GitLab 同期',
  'pages.repository.section.permissions': 'メンバー権限',
  'pages.repository.create.success': 'リポジトリを作成しました',
  'pages.repository.create.failed': 'リポジトリの作成に失敗しました',
  'pages.repository.update.success': 'リポジトリを更新しました',
  'pages.repository.update.failed': 'リポジトリの更新に失敗しました',
  'pages.repository.gitlab.sync': 'GitLab に同期',
  'pages.repository.gitlab.sync.description':
    'プロジェクト識別子を名前とする GitLab グループを先に作成し、その配下にリポジトリを作成します。リポジトリ URL は自動管理されます。',
  'pages.repository.gitlab.retrySync': 'GitLab 同期を再試行',
  'pages.repository.gitlab.retrySync.description':
    'このリポジトリは GitLab プロジェクトに未接続です。有効にして保存すると、グループとリポジトリを再作成または接続します。',
  'pages.repository.gitlab.creationOrder.title': 'GitLab 作成パス',
  'pages.repository.gitlab.creationOrder.description':
    '保存時に、プロジェクトグループ（名前とパスはプロジェクト識別子）→ リポジトリ（パスはリポジトリ識別子）の順で作成します。',
  'pages.repository.gitlab.editPermissions.title': 'GitLab メンバー権限の管理',
  'pages.repository.gitlab.editPermissions.description':
    '保存すると、SSF が管理するリポジトリメンバーのみ更新します。GitLab 上の他のメンバーは削除しません。',
  'pages.repository.gitlab.pendingIdentifier': '識別子未入力',
  'pages.repository.gitlab.memberPermissions.title': 'リポジトリメンバー',
  'pages.repository.gitlab.memberPermissions.managedOnly':
    'SSF 管理メンバーのみ',
  'pages.repository.gitlab.memberPermissions.description':
    '現在のプロジェクトの有効メンバーに権限を割り当てます。プロジェクトロールに基づく推奨値をリポジトリごとに変更できます。',
  'pages.repository.gitlab.memberPermissions.empty': 'メンバーが未割り当てです',
  'pages.repository.gitlab.memberPermissions.noProjectMembers':
    '割り当て可能な有効メンバーがいません。先にプロジェクト設定でメンバーを追加してください。',
  'pages.repository.gitlab.memberPermissions.loadFailed':
    'GitLab 権限を読み込めませんでした。メンバーの誤削除を防ぐため、再読み込みが成功するまで保存できません。',
  'pages.repository.gitlab.memberPermissions.loadUnavailable':
    '権限データを読み込めていないため、空の一覧としては扱いません。再読み込み後に編集してください。',
  'pages.repository.gitlab.memberPermissions.retry': '再読み込み',
  'pages.repository.gitlab.memberPermissions.tab': 'GitLab 権限',
  'pages.repository.gitlab.memberPermissions.save': '権限を保存',
  'pages.repository.gitlab.memberPermissions.saveSuccess':
    'GitLab 権限を保存しました',
  'pages.repository.gitlab.memberPermissions.saveFailed':
    'GitLab 権限の保存に失敗しました',
  'pages.repository.gitlab.memberPermissions.consistencyWarning':
    '画面の記録と GitLab の実際の権限が一致していない可能性があります',
  'pages.repository.gitlab.memberPermissions.consistencyWarning.description':
    '失敗したメンバーの GitLab ユーザー名と設定権限を確認し、修正後にもう一度保存して同期を再試行してください。',
  'pages.repository.gitlab.memberPermissions.syncStatus': '同期状態：',
  'pages.repository.gitlab.memberPermissions.syncStatus.synced': '同期済み',
  'pages.repository.gitlab.memberPermissions.syncStatus.pending': '同期待ち',
  'pages.repository.gitlab.memberPermissions.syncStatus.unmapped':
    'GitLab ユーザー未一致',
  'pages.repository.gitlab.memberPermissions.syncStatus.failed': '同期失敗',
  'pages.repository.gitlab.memberPermissions.syncStatus.notSynced': '未同期',
  'pages.repository.gitlab.memberPermissions.syncError': '失敗理由：{error}',
  'pages.repository.gitlab.memberPermissions.effectiveAccessLevel':
    'GitLab の有効な権限：{accessLevel}',
  'pages.repository.gitlab.memberPermissions.effectiveAccessLevel.unknown':
    '未確認',
  'pages.repository.gitlab.memberPermissions.inheritedAccess':
    'このメンバーは上位 GitLab グループから権限を継承しているため、リポジトリ単位では降格または取り消しできません。',
  'pages.repository.gitlab.member': 'プロジェクトメンバー',
  'pages.repository.gitlab.member.required': 'メンバーを選択してください',
  'pages.repository.gitlab.member.duplicate':
    '同じメンバーは重複して指定できません',
  'pages.repository.gitlab.member.placeholder': 'メンバーを選択',
  'pages.repository.gitlab.member.add': 'メンバー権限を追加',
  'pages.repository.gitlab.member.remove': 'メンバー権限を削除',
  'pages.repository.gitlab.accessLevel': 'GitLab 権限',
  'pages.repository.gitlab.accessLevel.required':
    'GitLab 権限を選択してください',
  'pages.repository.gitlab.accessLevel.10': 'Guest（ゲスト）',
  'pages.repository.gitlab.accessLevel.20': 'Reporter（レポーター）',
  'pages.repository.gitlab.accessLevel.30': 'Developer（開発者）',
  'pages.repository.gitlab.accessLevel.40': 'Maintainer（メンテナー）',
  'pages.repository.gitlab.projectContext.loadFailed':
    'プロジェクト識別子またはメンバーを読み込めませんでした。権限設定が不完全な可能性があります。',
  'pages.repository.gitlab.memberSync.unknownError': '不明な理由',
  'pages.repository.gitlab.memberSync.partialFailure':
    '{count} 人の権限同期に失敗しました：{details}',
  'pages.repository.gitlab.memberSync.inheritedAccess':
    '{count} 人は上位 GitLab グループから権限を継承しているため、リポジトリ単位では降格または取り消しできません：{members}',
  'pages.repository.gitlab.sync.alreadyExists':
    '同名の GitLab リポジトリが存在するため接続しました',
  'pages.repository.gitlab.sync.success':
    'GitLab プロジェクトグループ {groupPath} に同期しました',
  'pages.repository.gitlab.sync.incomplete': 'GitLab 同期未完了：{reason}',
  'pages.repository.gitlab.sync.createFailed':
    'ローカルリポジトリは作成されましたが、GitLab 同期に失敗しました。編集画面から再試行できます。',
};
